// extracted by mini-css-extract-plugin
module.exports = {"container":"HUD_container__331cn","buttons":"HUD_buttons__knhNV","globe":"HUD_globe__ctF8s"};